module.exports = __webpack_public_path__ + "static/media/paperclip.7f071999.png";